<template>
  <b-modal :visible="value" title="Available Diagrams" @hide="onHideModal">
    <b-row>
      <b-col v-for="diagram in diagrams" :key="diagram.id.$oid" md="auto">
        <b-button variant="rounded" @click.prevent="fetchDiagram(diagram)">
          Diagram {{ mappedDiagrams[diagram['diagram-type']] }}
          <Icon name="download" />
        </b-button>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button variant="link" @click="onHideModal">Close</b-button>
      <b-button
        v-if="isSuperadmin || isDownloadAccess"
        variant="rounded"
        class="ml-0"
        @click="editFeederDiagrams"
      >
        Edit
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import config from '@/config';
import getFile from '@/lib/get-file';
import { mappedDiagrams } from '@/components/shared/fault-consts';
import UsersMethods from '@/components/mixins/users-methods';

export default {
  name: 'FeederDiagramModal',
  mixins: [UsersMethods],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    feederDiagramParent: {
      type: String,
      required: true
    },
    feederNumber: Number,
    diagrams: Array
  },
  data() {
    return {
      mappedDiagrams
    };
  },
  computed: {
    feederParams() {
      const {
        projectCode,
        substationCode,
        externalVisnetHubId,
        externalGuardId
      } = this.$route.params;

      const coreParams = { projectCode, substationCode, feederNumber: this.feederNumber };
      const fetchUrlPrefix = `${config.API_URL}/api/v3/projects/${projectCode}/substations/${substationCode}/feeder_diagrams/`;

      return {
        VisnetHubFaultEventsPanel: {
          routeParams: {
            name: 'VisnetFeederDiagram',
            params: { ...coreParams, externalVisnetHubId }
          },
          filenamePrefix: `${projectCode}_${substationCode}_${externalVisnetHubId}_${this.feederNumber}_`,
          fetchUrlPrefix
        },
        Guard1000FaultPanel: {
          routeParams: {
            name: 'Guard1000FeederDiagram',
            params: { ...coreParams, externalGuardId }
          },
          filenamePrefix: `${projectCode}_${substationCode}_${externalGuardId}_${this.feederNumber}_`,
          fetchUrlPrefix
        }
      }[this.feederDiagramParent];
    }
  },
  methods: {
    editFeederDiagrams() {
      this.$router.push(this.feederParams.routeParams);
    },
    fetchDiagram(diagram) {
      const {
        'diagram-type': diagramType,
        id: { $oid: diagramId }
      } = diagram;
      const { filenamePrefix, fetchUrlPrefix } = this.feederParams;

      const filename = `${filenamePrefix}${diagramType}.pdf`;
      const fetchUrl = `${fetchUrlPrefix}${diagramId}`;

      getFile(fetchUrl, filename, { responseType: 'arraybuffer' });
    },
    onHideModal() {
      this.$emit('hideModal');
    }
  }
};
</script>
